<template>
    <a :class="`button_link button_link_${variant}`" :href="link">
        <span v-if="icon" :class="`icon icon-icon-${icon}`"></span>
        <span v-if="title">{{ title }}</span>
    </a>
</template>

<script>
export default {
    props: {
        link: {
            type: String,
            default: "#"
        },
        title: {
            type: String,
            default: "Click Here"
        },
        icon: "",

        variant: {
            type: String,
            default: "primary"
        }
    }
}
</script>

<style lang="scss" scoped>
.button_link {
    border-radius: 0.25rem;
    padding: 1rem;
    font-size: 0.875rem;
    font-weight: 700;
    line-height: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: relative;
    text-decoration: none;
    text-transform: uppercase;
    border: 1px solid var(--secondary_colour);
    transition: all 0.25s ease;
    @include tablet {
        font-size: 0.82rem;
    }

    .icon {
        margin-right: 0.5rem;
        font-size: 1.25rem;
        color: var(--secondary_colour);
    }

    &:hover {
        text-decoration: none;
        color: var(--primary_colour);
        background: var(--secondary_colour);

        .icon {
            color: var(--primary_colour);
        }
    }
    color: var(--quaternary_colour);
    background: var(--primary_colour);
}

.button_link_secondary {
    background: var(--secondary_colour);
    color: var(--primary_colour);

    .icon {
        color: var(--primary_colour);
    }

    &:hover {
        background: var(--primary_colour);
        color: var(--secondary_colour);

        .icon {
            color: var(--secondary_colour);
        }
    }
}
</style>
